import React, { useState } from "react";
import { Star, X } from "lucide-react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import "@splidejs/splide/dist/css/splide.min.css";
import styles from "../../../pages/styles";

const ReviewsCompact = ({ sectionClassName }) => {
  const [selectedTestimonial, setSelectedTestimonial] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  
  const testimonials = [
    {
      name: "Kelli Fogelberg",
      text: "Tech Tails is fantastic! The one-on-one teaching really enables my son to learn exactly what he wants to be able to do and keeps him engaged so he can achieve so much. He has had a couple of different teachers as he has explored different skills, and every one has been attentive and helpful.",
    },
    {
      name: "Cassie Laine Walters",
      text: "Okay wow. This is what you are looking for! When it comes to private zoom call video game building tutoring/training for your tech focused kids - this is it!! The instructors are deeply kind and patient and really truly know their stuff. My 9 year old son is homeschooled and on the spectrum. He loves video games and well he needs a job skill so might as well start him young right!? Also it has been really hard to find subjects that he has been interested in to encourage learning. Now with TechTails, they take his favorite books, games and tv shows and teach him how to make a fun game out of all of them. They are student lead, so they literally follow his lead with what he wants to learn/do/talk about. It is so empowering for him. It's like they're gently pushing him into learning - and that is exactly what he's been needing. I didn't want to homeschool my son, but programs like this make me feel like hes in the right place. He definitely would NOT get this kind of training nor attention in a public school setting. This definitely makes sense for us. Also you don't have to be homeschooled! This could be a fun afterschool activity too, and give them a leg up on the learning in the future. Do this. You won't regret it plus they have month-to-month options so you wont lose - youll gain experience even if its just for a month. I wish we had known about this sooner. They are a new company so I'm grateful we can get in while they're not booked out because I could see this becoming a waitlist school very quickly.",
    },
    {
      name: "Heidi Wray",
      text: "Our experience with Tech Tails has been fantastic! My first son enjoyed the challenge of building his roller coaster and appreciated how his teacher guided him through the process. Once he got the hang of it, he really had fun bringing his ideas to life. My daughter loves the one-on-one instruction, which has helped her learn to code, create her own characters, and even edit videos. She’s gained valuable skills in a way that feels exciting and creative. My second son enjoys his teacher and loves that he can design and play his own video games. It’s been a great way for him to develop his creativity and technical skills in an engaging way. Overall, Tech Tails has provided a great learning experience with supportive teachers who make the process enjoyable. Highly recommend!",
    },
    {
      name: "Amanda Ann Autrey",
      text: "My 6 year old son started with Tech Tails 4 months ago. It's my son's favorite class. He spends an hour once a week on zoom with his instructor Skyler. My son is super engaged in every lesson. The instructor really works with whatever level our child is at with everything. Our little guy isn't reading that well yet, but his instructor has helped work out systems and matches his level of understanding helping him find which buttons to press and is helping me learn the software to build games already. My son loves this creative outlet. He always ends class feeling confident and accomplished. I love it! Listening in on class the instructor is so smart and patient. It's a wonderful environment and really great for this tech gen we're raising. I recommend it! Worth every penny! My son has been playing with digital drawing to incorporate into his game designs! I'm always blown away by how smart this gen is and they need smart outlets like this. Highly recommended, planning to keep him going for the foreseeable future.",
    },
    {
      name: "Andrea Grieve",
      text: "We have been looking for something like this for our son who has some learning limitations for a very long time. Tech Tails has been a godsend. Skyler’s ability to clearly communicate coding principles with our son is unmatched. He is very positive and has a wonderful and patient teaching technique. I’m actually amazed at how he tailors the lessons to what our son needs. Also, I love that Andrew and Skyler communicate clearly and quickly with me. Huge props to Tech Tails for filling a much needed hole in the digital community",
    },
    {
      name: "Renae Beck",
      text: "At first we were hesitant to sign up but I’m so glad we did, my two kids 8 and 10 both love this so much, the teacher has been awesome at walking them through the process of game design and lets their creativity be the guide. Then teaches them how to create whatever they talk about he can figure out how to help them put it into the game.",
    },
    {
      name: "Danielle Shettell",
      text: "My 10 year old son LOVES his Tech Tails class. His teacher Skyler is so patient and compassionate and works with him right on his level. It is one ability to know computer programming, another ability to teach it in person, and a completely different ability to teach this skill online to children. Skyler has all those abilities! I am very impressed and grateful. My son has learned so much and looks forward every week for classes. We will be continuing students for sure. Thanks Tech Tails!",
    },
    {
      name: "Mikensi Jung",
      text: "My 11yo started in August and is still a current student. He wanted to learn how to be a Roblox game developer. He has learned how to animate and is still creating a game. He loves his instructors and says they're 'cool' and I like how great they are with kids!",
    },
      {
        name: "Robin Christensen",
        text: "Tech Tails has been a great program and experience for our Grandson. He is not one that is interested in sports so we were looking for something along the line of his interests. Skylar and the rest of the team are knowledgeable and experienced at what they do. Our grandson looks forward to his class every week He is really enjoying what hes learning. Especially the one on one approach where he can move at his pace. Would highly recommend for any of those that are looking for a program such as this. Definitely worth the investment. Thanks, Tech Tails for all you do!",
      },
  ];

  return (
    <section className={`${sectionClassName || "pt-16 sm:pt-18 pb-4 lg:pt-14 md:pb-6"} overflow-hidden`}>
      <div className="mx-auto">
        <div className="mb-6 md:mb-8 px-6 md:px-4">
          <p
            className={`${styles.biggerheadingdark} text-center mb-3 md:mb-4`}
          >
            Families <span className="text-pinkprimary italic pr-0.5">really</span> love Tech Tails
          </p>
          <p className={`${styles.paragraph} md:px-0 text-center`}>
            Real feedback from parents who've seen their kids thrive
          </p>
        </div>

        {/* Splide slider with fixed slide width and AutoScroll extension */}
        <Splide
          options={{
            type: "loop",
            fixedWidth: "320px", // fixed slide width so they don't resize
            fixedHeight: "240px", // fixed height for consistency
            drag: "free",
            gap: "20px", // consistent gap between slides
            arrows: false,
            pagination: false,
            autoScroll: {
              speed: 0.75, // adjust for desired continuous scroll speed
              pauseOnHover: true,
              pauseOnFocus: true,
            },
          }}
          extensions={{ AutoScroll }}
          className="py-2"
          onDrag={() => setIsDragging(true)}
          onDragged={() => setTimeout(() => setIsDragging(false), 100)}
        >
          {testimonials.map((testimonial, index) => (
            <SplideSlide key={index}>
              <div className="w-full bg-white rounded-xl p-4 border-2 border-gray-200 hover:border-orangeprimary transition-all shadow-md hover:shadow-xl flex flex-col h-full">
                <div className="flex items-center gap-1 mb-2">
                  <Star className="w-4 h-4 fill-yellow-400 stroke-yellow-400" />
                  <Star className="w-4 h-4 fill-yellow-400 stroke-yellow-400" />
                  <Star className="w-4 h-4 fill-yellow-400 stroke-yellow-400" />
                  <Star className="w-4 h-4 fill-yellow-400 stroke-yellow-400" />
                  <Star className="w-4 h-4 fill-yellow-400 stroke-yellow-400" />
                  <span className="ml-2 text-sm font-semibold text-gray-600">5.0</span>
                </div>
                
                <div className="flex-1 mb-3 min-h-0">
                  <p className={`${styles.paragraph} line-clamp-3 leading-normal text-gray-700 mb-2`}>
                    "{testimonial.text}"
                  </p>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setSelectedTestimonial(testimonial);
                    }}
                    onMouseDown={(e) => {
                      e.stopPropagation();
                    }}
                    className="text-sm text-gray-500 hover:text-pinkprimary hover:underline transition-colors"
                  >
                    Read full review
                  </button>
                </div>
                
                <div className="pt-3 border-t border-gray-200 mt-auto">
                  <p className={`${styles.paragraph} font-semibold mb-0 text-darkprimary text-sm`}>
                    — {testimonial.name}
                  </p>
                </div>
              </div>
            </SplideSlide>
          ))}
        </Splide>

        {selectedTestimonial && (
          <div
            className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4 backdrop-blur-sm"
            onClick={() => setSelectedTestimonial(null)}
          >
            <div
              className="bg-white rounded-xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 relative border border-darkprimary shadow-md"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={() => setSelectedTestimonial(null)}
                className="absolute top-4 right-4 text-darkprimary hover:text-pinkprimary transition-colors"
              >
                <X size={24} />
              </button>
              <div className="flex items-center gap-2 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-yellow-400 stroke-yellow-400" />
                ))}
              </div>
              <p className={`${styles.paragraph} mb-4`}>
                {selectedTestimonial.text}
              </p>
              <p className={`${styles.paragraph} font-semibold`}>
                {selectedTestimonial.name}
              </p>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default ReviewsCompact;
